import { Injectable } from '@angular/core'
import { ConfigService as RecoveryConfigService, AppEnvironment } from '@recovery/recovery-unified-ui-common'

@Injectable({
  providedIn: 'root'
})
export class ModuleConfigService   {
  public readonly application_name: 'Recovery Inventory Management';
  public readonly isLocal: boolean = false;
  public readonly isTest: boolean = true;
  public readonly production: boolean = true;
  public readonly navigationMode: string = 'top';
  public readonly tokenCacheTimeout: number = 3600000
  public readonly rimApiUrl: string
  public readonly rimEndPoint: string
  public readonly localMockDataUrl : string
  public readonly emdsUrl : string
  public readonly matomoId: string
  public readonly unifiedUiRedirectFlag : boolean
  public readonly env : string
  public readonly useDoc360 : boolean

  public readonly notification: any = {
    position: 'relative',
    messageRole: 'alertdialog',
    closeButton: true,
    animationType: 'fadeAnimation',
    autoClose: true,
    messageVisibleTime: '10000',
    animationTime: '.5'
  }

  public readonly oauth: any = {
    issuer:  'https://ssoiamcorp-nonprod.uhg.com',
    loginUrl: 'https://ssoiamcorp-nonprod.uhg.com/as/authorization.oauth2',
    logoutUrl: 'https://ssoiamcorp-nonprod.uhg.com/idp/startSLO.ping',
    redirectUri: 'https://rim-dev.optum.com',
    silentRefreshUri: 'https://rim-dev.optum.com/silent-refresh.html',
    clientId: 'RIM_DEV',
    responseType: 'id_token token',
    scope: 'openid profile address email phone',
    acr_values: 'R1_AAL1_MS-AD-AAL1_MS-AD-Kerberos',
    autoRefresh: true
  };

  redirectUri= 'https://rim-dev.optum.com';
  silentRefreshUri= 'https://rim-dev.optum.com/silent-refresh.html';
  clientSecret= 'Xt10tM9vDOpKUNEK8uImNkU5YYNGBpwYKyYtgqcmw9Eidq9Wzg0rSxeev0JRsMWe';
  clientId= 'RIM_DEV';
  responseType= 'id_token token';
  scope= 'openid profile address email phone';
  acr_values= 'R1_AAL1_MS-AD-AAL1_MS-AD-Kerberos';
  autoRefresh= true;



  public readonly idleTimeout: number = 900
  public readonly odarUidLinkPrefix: string
  public readonly unifiedUiUrl: string
  public readonly unifiedAuthApi: string
  public readonly azureClientId: string
  public readonly nonCashFeatureFlag: boolean = true
  public readonly tracrBatchFeatureFlag: boolean
  public readonly commercialAdminFeatureFlag: boolean = true // Remove in future
  public readonly ofrFeatureFlag: boolean


  constructor(private readonly configService: RecoveryConfigService) {
    this.oauth.issuer = this.getIssuer();
    this.oauth.loginUrl = this.getLoginUrl();
    this.oauth.logoutUrl = this.getLogoutUrl();
    this.oauth.redirectUri = this.getRedirectUri();
    this.oauth.silentRefreshUri = this.getSilentRefreshUrl();
    this.oauth.clientId = this.getClientId();
    this.oauth.responseType = 'id_token token';
    this.oauth.scope = 'openid profile address email phone';
    this.oauth.acr_values = 'AAL1_MS-AD-Kerberos';
    this.oauth.autoRefresh = true;

    this.rimApiUrl = this.getRimApiUrl();
    this.rimEndPoint = '/api/paymentintegrity/recovery/rim/v1.0';
    this.localMockDataUrl = './assets/mockdata';
    this.emdsUrl = 'https://edms-idrs-ui.uhc.com/idrs/viewer?';
    this.idleTimeout = 900;
    this.matomoId = this.getMatomoId();
    this.useDoc360 = true;
    this.unifiedUiRedirectFlag = this.getUnifiedUiRedirectFlag();
    this.unifiedUiUrl = this.getUnifiedUiUrl();
    this.unifiedAuthApi = this.getUnifiedAuthApi();
    this.azureClientId = this.getAzureClientId();
    this.env = this.getEnv();
  }

  public getIssuer(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
      case AppEnvironment.Development:
      case AppEnvironment.Test:
        return 'https://ssoiamcorp-nonprod.uhg.com'
      case AppEnvironment.Staging:
        return 'https://ssoiamcorp-stage.uhg.com'
      case AppEnvironment.Production:
        return 'https://ssopacorp.uhg.com'
      default:
        return 'https://ssoiamcorp-nonprod.uhg.com'
    }
  }

  public getLoginUrl(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'https://ssoiamcorp-nonprod.uhg.com/as/authorization.oauth2'
      case AppEnvironment.Development:
        return 'https://ssoiamcorp-nonprod.uhg.com/as/authorization.oauth2'
      case AppEnvironment.Test:
        return 'https://ssoiamcorp-nonprod.uhg.com/as/authorization.oauth2'
      case AppEnvironment.Staging:
        return 'https://ssoiamcorp-stage.uhg.com/as/authorization.oauth2'
      case AppEnvironment.Production:
        return 'https://ssopacorp.uhg.com/as/authorization.oauth2'
      default:
        return 'https://ssoiamcorp-nonprod.uhg.com/as/authorization.oauth2'
    }
  }

  public getLogoutUrl(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'https://ssoiamcorp-nonprod.uhg.com/idp/startSLO.ping'
      case AppEnvironment.Development:
        return 'https://ssoiamcorp-nonprod.uhg.com/idp/startSLO.ping'
      case AppEnvironment.Test:
        return 'https://ssoiamcorp-nonprod.uhg.com/idp/startSLO.ping'
      case AppEnvironment.Staging:
        return 'https://ssoiamcorp-stage.uhg.com/idp/startSLO.ping'
      case AppEnvironment.Production:
        return 'https://ssopacorp.uhg.com/idp/startSLO.ping'
      default:
        return 'https://ssoiamcorp-nonprod.uhg.com/idp/startSLO.ping'
    }
  }

   public getClientId(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'RIM_LOCAL'
      case AppEnvironment.Development:
        return 'RIM_DEV'
      case AppEnvironment.Test:
        return 'RIM_TEST'
      case AppEnvironment.Staging:
        return 'RIM_STAGE'
      case AppEnvironment.Production:
        return 'RIM_PROD'
      default:
        return 'RIM_DEV'
    }
  }

  public getRedirectUri(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'http://localhost:4200'
      case AppEnvironment.Development:
        return 'https://rim-dev.optum.com'
      case AppEnvironment.Test:
        return 'https://rim-test.optum.com'
      case AppEnvironment.Staging:
        return 'https://rim-stage.optum.com'
      case AppEnvironment.Production:
        return 'https://rim.optum.com'
      default:
        return 'https://rim-dev.optum.com'
    }
  }

  public getSilentRefreshUrl(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'https://localhost:4200/silent-refresh.html'
      case AppEnvironment.Development:
        return 'https://rim-dev.optum.com/silent-refresh.html'
      case AppEnvironment.Test:
        return 'https://rim-test.optum.com/silent-refresh.html'
      case AppEnvironment.Staging:
        return 'https://rim-stage.optum.com/silent-refresh.html'
      case AppEnvironment.Production:
        return 'https://rim.optum.com/silent-refresh.html'
      default:
        return 'https://rim-dev.optum.com/silent-refresh.html'
    }
  }


  public getRimApiUrl(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'http://localhost:55838'
      case AppEnvironment.Development:
        return 'https://odar-api-dev.optum.com/rim'
      case AppEnvironment.Test:
        return 'https://odar-api-test.optum.com/rim'
      case AppEnvironment.Staging:
        return 'https://odar-api-stage.optum.com/rim'
      case AppEnvironment.Production:
        return 'https://odar-api.optum.com/rim'
      default:
        return 'https://odar-api-dev.optum.com/rim'
    }
  }

  public getEmdsUrl(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'https://edms-idrs-ui-sys.uhc.com/idrs/viewer?'
      case AppEnvironment.Development:
        return 'https://edms-idrs-ui-dev.uhc.com/idrs/viewer?'
      case AppEnvironment.Test:
        return 'https://edms-idrs-ui-sys.uhc.com/idrs/viewer?'
      case AppEnvironment.Staging:
        return 'https://edms-idrs-ui-stg.uhc.com/idrs/viewer?'
      case AppEnvironment.Production:
        return 'https://edms-idrs-ui.uhc.com/idrs/viewer?'
      default:
        return 'https://edms-idrs-ui-dev.uhc.com/idrs/viewer?'
    }
  }

  public getMatomoId(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return '71'
      case AppEnvironment.Development:
        return '72'
      case AppEnvironment.Test:
        return '71'
      case AppEnvironment.Staging:
        return '73'
      case AppEnvironment.Production:
        return '74'
      default:
        return 'https://edms-idrs-ui-dev.uhc.com/idrs/viewer?'
    }
  }

  public getUnifiedUiRedirectFlag(): boolean {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return false
      case AppEnvironment.Development:
      case AppEnvironment.Test:
      case AppEnvironment.Staging:
      case AppEnvironment.Production:
        return true
      default:
        return false
    }
  }

  public getUnifiedUiUrl(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
      case AppEnvironment.Development:
        return 'https://reco-dev.optum.com'
      case AppEnvironment.Test:
        return 'https://reco-tst.optum.com'
      case AppEnvironment.Staging:
        return 'https://reco-stg.optum.com'
      case AppEnvironment.Production:
        return 'https://reco-prd.optum.com'
      default:
        return 'https://reco-tst.optum.com'
    }
  }

  public getUnifiedAuthApi(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'http://localhost:8080/'
      case AppEnvironment.Development:
      case AppEnvironment.Test:
      case AppEnvironment.Staging:
      case AppEnvironment.Production:
        return `https://reco-unified-auth-api-${this.getEnv()}.optum.com/`
      default:
        return `https://reco-unified-auth-api-dev.optum.com/`
    }
  }

  public getAzureClientId(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
      case AppEnvironment.Development:
        return '6b3b8d49-6e6c-434c-869b-b64443f3772b'
      case AppEnvironment.Test:
        return 'f67cb30b-1553-485b-8c82-9e76443b012f'
      case AppEnvironment.Staging:
        return 'dc653979-fa9e-4dfa-a703-127dd548a825'
      case AppEnvironment.Production:
        return 'f008d25c-a4a5-49a8-9bc4-97a18b7f7d8a'
      default:
        return '6b3b8d49-6e6c-434c-869b-b64443f3772b'
    }
  }

  public getEnv(): string {
    switch (this.configService.env) {
      case AppEnvironment.Local:
        return 'local'
      case AppEnvironment.Development:
        return 'dev'
      case AppEnvironment.Test:
        return 'tst'
      case AppEnvironment.Staging:
        return 'stg'
      case AppEnvironment.Production:
        return 'prd'
      default:
        return 'dev'
    }
  }
}
